import { styled } from '@/stitches.config';

const Paragraph = styled('p', {
  margin: '$0',
});

export default Paragraph;
